import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { Divider, Grid, Typography } from "@mui/material";
import CustomAppBar from "../../../components/CustomAppBar";
import { useLocation, useNavigate } from "react-router";
import RoundButton from "../../../components/RoundButton";
import ReservationCheckoutCard from "../../../components/reservation/ReservationCheckoutCard";
import selectedIcon from "../../../constants";
import { useDispatch, useSelector } from "react-redux";
import {
  extendReservation,
  reservationsBookRequest,
} from "../../../redux/reservations/action";
import moment from "moment-timezone";
import storePersist, { localConstant } from "../../../services/localStorage";
import CustomLoader from "../../../components/CustomLoader";
import MenuBar from "../../menuBar";
import { useResponsive } from "../../../hooks/useResponsive";
import { updateReservationCheckout } from "../../../redux/reservations/constants";
import {
  MOMENT_CONSTANTS,
  convertUtcToYard,
  getMonthlyToDate,
  convertYardToUtc,
} from "../../../utils/momentUtils";
import { useTranslation } from "react-i18next";
import { getSpotTitle } from "../../../utils/utils";
import { truncateLocationName } from "../../../utils";

const CheckOutReservationPage = () => {
  const { isLoading } = useSelector((state) => state.reservationReducer);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lgUp = useResponsive("up", "lg");

  const selectedclusterName = (clusterType) => {
    switch (clusterType) {
      case "TRUCK":
        return `${t("pages.reservationType.text04")}`;

      case "TRAILER":
        return `${t("pages.reservationType.text05")}`;

      case "TRUCK_AND_TRAILER":
        return `${t("pages.reservationType.text04")} + ${t(
          "pages.reservationType.text05",
        )}`;

      default:
        return null;
    }
  };

  const {
    deposit,
    net,
    totalTax,
    subTotalCost,
    vehicleList,
    numOfDays,
    fromDate,
    locationId,
    reservationType,
    reservationId,
    timeZone,
    time,
    isExtend = false,
  } = location?.state;

  const hours = time?.split(":")?.[0];

  const currentDate = isExtend
    ? convertUtcToYard({ date: fromDate, timeZone: timeZone })
    : moment(fromDate).add({ hour: hours });
  const futureDate =
    reservationType === "DAILY"
      ? moment(currentDate).add(numOfDays, "days")
      : getMonthlyToDate({ date: currentDate.clone(), enableFormat: false });

  const futureDate24Hours =
    reservationType === "DAILY"
      ? moment(currentDate).add(numOfDays, "days")
      : // : moment(currentDate).add(1, "months");
        getMonthlyToDate({ date: currentDate.clone(), enableFormat: false });
  const daysCount = moment(futureDate).diff(moment(currentDate), "days") + 1; /// add 1 day to add current days
  const daysDiffrence =
    reservationType === "DAILY"
      ? `${numOfDays} ${
          numOfDays === 1 ? "day" : `${t("pages.reservationType.text13")}`
        }`
      : `${daysCount} ${
          daysCount === 1 ? "day" : `${t("pages.reservationType.text03")}`
        }`;

  const [checkoutList, setCheckoutList] = useState([]);

  useEffect(() => {
    if (vehicleList?.length) {
      const finalVehicleList = vehicleList?.filter(function (item) {
        return item.selectedCount > 0;
      });
      setCheckoutList(finalVehicleList);
    }
  }, [vehicleList]);

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <CustomAppBar
        title={t("pages.checkOutReservation.pageHeading")}
        showBackButton={true}
        onBackButtonClick={() => {
          navigate(-1);
        }}
      />
      <MenuBar />

      <Box
        overflow="hidden"
        sx={{
          m: lgUp ? 3.5 : 1,
          mb: 2,
          display: "flex",
          flexDirection: "column",
          height: "85vh",
          overflowY: "scroll",
          minHeight: "600px",
        }}
        position={"relative"}
      >
        <Grid container direction={"column"} sx={{ mt: 2 }}>
          <Typography variant="h5" color={"primary.main"}>
            {t("pages.checkOutReservation.title01")}
          </Typography>
          <Typography variant="body2" color={"primary.secondary"}>
            {`${location?.state?.isExtend ? "Extend" : ""} ${t(
              "pages.reservationType.text01",
            )} ${currentDate?.format(
              reservationType === "DAILY"
                ? MOMENT_CONSTANTS.dateWithTime.monthDay12Hours
                : MOMENT_CONSTANTS.date.shortMonthDay,
            )}  to ${futureDate24Hours?.format(
              reservationType === "DAILY"
                ? MOMENT_CONSTANTS.dateWithTime.monthDay12Hours
                : MOMENT_CONSTANTS.date.shortMonthDay,
            )} (${daysDiffrence})`}
          </Typography>
          {reservationId ? (
            <Typography variant="body2" color={"primary.secondary"}>
              {`Reservation Id - ${reservationId}`}
            </Typography>
          ) : (
            <></>
          )}
          <Typography variant="h5" color={"primary.secondary"}>
            {truncateLocationName(
              location.state?.reservationState?.location_display_name,
            )}
          </Typography>
          <Typography variant="body2" color={"primary.secondary"}>
            {location.state?.reservationState?.location_address_line_1}
          </Typography>
        </Grid>
        <Stack sx={{ mt: 2 }} spacing={2}>
          <Divider width={"100%"} />
          {checkoutList?.length &&
            checkoutList?.map((data, index) => {
              return (
                <div key={index}>
                  <ReservationCheckoutCard
                    children={selectedIcon(data?.clusterType)}
                    type={getSpotTitle(data?.clusterType)}
                    spotLimit={
                      parseInt(data?.spotLimit) - parseInt(data?.selectedCount)
                    }
                    spotAvailable={"10 spots available"}
                    chargePerDay={
                      data.reservationType === "DAILY"
                        ? `$ ${data?.price}/per day`
                        : `$ ${data?.price}/per month`
                    }
                    selectedCount={data?.selectedCount}
                    totalCost={data?.totalCost}
                  />
                  <Divider width={"100%"} />
                </div>
              );
            })}
        </Stack>
        <Stack sx={{ mt: 2 }} spacing={2} paddingBottom={"50px"}>
          <Grid
            container
            direction={"row"}
            sx={{ mt: 2, justifyContent: "space-between" }}
          >
            <Typography variant="body2" color={"primary.secondary"}>
              {t("pages.checkOutReservation.text02")}
            </Typography>
            <Typography variant="body2" color={"#3A4454"}>
              {`$${subTotalCost?.toFixed(2)}`}
            </Typography>
          </Grid>
          <Grid
            container
            direction={"row"}
            sx={{ mt: 2, justifyContent: "space-between" }}
          >
            <Typography variant="body2" color={"primary.secondary"}>
              {t("pages.checkOutReservation.text01")}
            </Typography>
            <Typography variant="body2" color={"#3A4454"}>
              {`$${totalTax?.toFixed(2)}`}
            </Typography>
          </Grid>
          {reservationType === "MONTHLY" && (
            <Grid
              container
              direction={"row"}
              sx={{ mt: 2, justifyContent: "space-between" }}
            >
              <Typography variant="body2" color={"primary.secondary"}>
                Deposit
              </Typography>
              <Typography variant="body2" color={"#3A4454"}>
                {`$${deposit?.toFixed(2)}`}
              </Typography>
            </Grid>
          )}
          <Divider width={"100%"} />
          <Grid
            container
            direction={"row"}
            sx={{ mt: 2, justifyContent: "space-between" }}
          >
            <Typography variant="h5" color={"primary.secondary"}>
              {t("pages.checkOutReservation.text03")}
            </Typography>
            <Typography variant="h5" color={"primary.secondary"}>
              {`$${net?.toFixed(2)}`}
            </Typography>
          </Grid>
        </Stack>
        <Box
          width={"100%"}
          backgroundColor="white"
          position="sticky"
          bottom={0}
        >
          <RoundButton
            sx={{ mt: 5, mb: 3 }}
            style={{
              width: "100%",
            }}
            disabled={isLoading}
            size="large"
            fullWidth
            variant="contained"
            type="submit"
            color="primary"
            rounded
            onClick={() => {
              if (isExtend) {
                dispatch(
                  extendReservation(
                    {
                      reservationId: location?.state?.reservationId,
                      numOfDays,
                    },
                    (response) => {
                      if (!response) {
                        navigate(-1);
                        return;
                      }
                      navigate("/makePayment", {
                        state: {
                          ...response,
                          isExtend: true,
                          billing: {
                            charges: [
                              {
                                totalAmount: response?.billing?.[0]?.dueAmount,
                                billNums: response?.billing?.[0]?.dueBillNums,
                              },
                            ],
                          },
                          reservationId,
                        },
                      });
                    },
                  ),
                );
                return;
              }
              const hours = time?.split(":")?.[0];
              const dateSelected = convertYardToUtc({
                date: moment(fromDate).set({ hour: hours }),
                timeZone: timeZone,
              });
              const dateSelectedForDaily = convertYardToUtc({
                date: moment(fromDate).set({ hour: hours }),
                timeZone: timeZone,
              });

              const customer_id = storePersist.get(
                localConstant.ENTITY_CUSTOMER_ID,
              );

              const dateValue =
                reservationType === "DAILY"
                  ? dateSelectedForDaily
                  : dateSelected;
              const finalReservationData = {
                customerId: customer_id,
                preAllocatedSpots: "NO",
                reservationType: reservationType,
                fromDate: dateValue,
                numOfDays: numOfDays,
                spotAllocationCriteria: [
                  {
                    locationId: locationId,
                    spots: checkoutList.map(function (item, index) {
                      return {
                        spotType: item?.clusterType,
                        count: item?.selectedCount,
                      };
                    }),
                  },
                ],
              };
              console.log("yes-button-clicked");
              dispatch(
                reservationsBookRequest(finalReservationData, (response) => {
                  if (response?.customerId) {
                    const resParam = {
                      ...response,
                      ...{
                        isReserve: true,
                      },
                      time: time,
                    };
                    dispatch(updateReservationCheckout({}));
                    navigate("/makePayment", { state: resParam });
                  }
                }),
              );
            }}
            spacing={2}
          >
            <Typography variant="buttonText" color="common.buttonText">
              {t("pages.checkOutReservation.title01")}
            </Typography>
          </RoundButton>
        </Box>
      </Box>

      {isLoading && <CustomLoader />}
    </div>
  );
};

export default CheckOutReservationPage;
